import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { can } from '../../../services';
import { getRole } from '../../../reducers';
import EventTable from 'eventTable';
import Loading from 'components/Loading';
import { requestPhaseItemEventList } from 'actionCreators';
import { Dialog, FontIcon } from 'react-toolbox';
import { ThemeProvider } from 'react-css-themr';
import S from './itemEvents.scss';
import { cutQuantityString } from '../../../utils/lineItemUtils';

const theme = { RTDialog: S };

class ItemEvents extends Component {
  state = { active: false };

  toggleActive = () => {
    const active = !this.state.active;
    if (!this.props.levelerEvents) this.loadEvents();
    this.setState({ active });
  }

  loadEvents = () =>
    this.props.requestPhaseItemEventList(this.props.itemType, this.props.lineItem);

  render = () => {
    const { active } = this.state;
    const { display, lineItem, levelerItem, loading, dataKeys,
            canView, levelerEvents } = this.props;
    if (!display) return null;
    if (!canView) return <td className={S.container} />;
    let itemEvents = [];
    let events = [];
    if (levelerEvents) {
      itemEvents = levelerItem.events || [];
      events = itemEvents || [];
    } else {
      itemEvents = lineItem.events || [];
      events = itemEvents || [];
    }
    if (dataKeys.includes('cut_quantity')) {
      itemEvents.forEach((event, index) => {
        if (event.data && event.data.cut_quantity) {
          const newEvent = {
            ...event,
            data: {
              ...event.data,
              cut_quantity: cutQuantityString(event.data.warehouse_quantity),
            },
          };
          events[index] = newEvent; // Replace the event in the same index
        }
      });
    }
    return (<td className={S.container}>
      <FontIcon value="ic_history" className={S.history_icon} onClick={this.toggleActive} />
      {active && <ThemeProvider theme={theme}>
        <Dialog active={active} onEscKeyDown={this.toggleActive}>
          <FontIcon value="close" className={S.close_icon} onClick={this.toggleActive} />
          {loading && <Loading />}
          {!loading && <EventTable
            events={events}
            dataKeys={dataKeys}
          />}
        </Dialog>
      </ThemeProvider>}
    </td>);
  }
}

ItemEvents.defaultProps = {
  dataKeys: [],
  levelerEvents: false,
  lineItem: null,
  levelerItem: null,
};

ItemEvents.propTypes = {
  display: PropTypes.bool.isRequired,
  itemType: PropTypes.string.isRequired,
  lineItem: PropTypes.object,
  levelerItem: PropTypes.object,
  label: PropTypes.string.isRequired,
  requestPhaseItemEventList: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  dataKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
  canView: PropTypes.bool.isRequired,
  levelerEvents: PropTypes.bool,
};

export default connect((state, ownProps) => ({
  loading: state.phase[ownProps.itemType].loading,
  canView: can(getRole(state), 'view', 'event'),
}), { requestPhaseItemEventList })(ItemEvents);



// WEBPACK FOOTER //
// ./client/app/shared/components/LineItemTable/itemEvents.jsx